import PickingCardDetail from '@/models/PickingForDelivery/PickingCardDetail';

export default class PickingCardDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingForDeliveryId  = '';
		this.pickingForDeliveryPickingNumber = '';
		this.pickingDetailId  = '';
		this.pickingDetailDeliveryInstructionDetail = '';
		this.deliveryCardId  = '';
		this.deliveryCardDeliveryCardNumber = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.scanDateFrom = '';
		this.scanDateTo = '';
		this.scanById  = '';
		this.scanByFirstName = '';
		this.deliveryQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingForDeliveryId : '0',
			pickingForDeliveryPickingNumber : '0',
			pickingDetailId : '0',
			pickingDetailDeliveryInstructionDetail : '0',
			deliveryCardId : '0',
			deliveryCardDeliveryCardNumber : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			scanDateFrom : '0',
			scanDateTo : '0',
			scanById : '0',
			scanByFirstName : '0',
			deliveryQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}